import { css, styled } from 'styled-components';

import { colorPrimary600 } from 'app/style/colors';
import { focus } from 'app/style/mixins';
import { spacing1, spacing4 } from 'app/style/spacing';

interface StyledButtonProps {
    $active: boolean;
}

export const StyledContainer = styled.div`
    margin-top: ${spacing1};
`;

export const StyledTabs = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${spacing4};
    align-items: stretch;
`;

export const StyledContent = styled.div`
    &::after {
        position: absolute;
        content: '';
        bottom: 0;
        left: 0;
        right: 0;
        width: 50%;
        margin: 0 auto;
        border-bottom: 2px solid ${colorPrimary600};
    }
`;

export const StyledButton = styled.button<StyledButtonProps>`
    background: none;
    border: 0;
    position: relative;
    margin: auto ${spacing1} 0;
    cursor: pointer;
    ${({ $active }) =>
        !$active &&
        css`
            opacity: 0.6;

            ${StyledContent} {
                &::after {
                    display: none;
                }

                &:hover {
                    &::after {
                        display: block;
                    }
                }
            }
        `}

    ${focus};
`;
